import { IconDefinitionProps } from "@toolkit/Framework/Types/Icon";
import React, { ComponentType } from "react";
import { renderToStaticMarkup } from "react-dom/server";

const getIconDataSrc = <T extends IconDefinitionProps>(Icon: ComponentType<any>, iconProps?: T, iconType = "svg") => {
    if (typeof window === "undefined") {
        return "";
    }

    return `data:image/${iconType}+xml;base64,${window.btoa(renderToStaticMarkup(<Icon {...iconProps} />))}`;
};

export default getIconDataSrc;
